<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/caserecord' }"
        >管理后台</el-breadcrumb-item
      >
      <el-breadcrumb-item>案件查询记录</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <!-- 搜索栏 -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input placeholder="输入姓名" v-model="queryInfo.name"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="getCasesQueryRecords"
            >搜 索</el-button
          >
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="exprotData">导 出</el-button>
        </el-col>
      </el-row>

      <!-- 案件列表 -->
      <el-table border stripe :data="caseRecords">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="姓名" prop="name"></el-table-column>
        <el-table-column label="身份证号码" prop="id_card"></el-table-column>
        <el-table-column label="手机号码" prop="phone"></el-table-column>
        <el-table-column label="合同编号" prop="contract_no"></el-table-column>
        <el-table-column
          label="是否愿意调解"
          prop="agree_mediate"
        ></el-table-column>
        <el-table-column label="查询时间" prop="add_time"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="removeById(scope.row.id)"
              >删 除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "CaseQueryRecord",
  data() {
    return {
      //   案件查询记录列表
      caseRecords: [],
      // 查询参数对象
      queryInfo: {
        name: "",
        pagenum: 1,
        pagesize: 10,
      },
      // 总数据条数
      total: 0,
    };
  },
  created() {
    this.getCasesQueryRecords();
  },
  methods: {
    // 根据分页获取对应的案件查询记录列表
    async getCasesQueryRecords() {
      const { data: res } = await this.$http.get("casesquery", {
        params: this.queryInfo,
      });

      if (res.meta.status !== 200) {
        return this.$message.error("获取案件查询记录列表失败！");
      }
      this.$message.success("获取案件查询记录列表成功！");
      //   console.log(res.data);
      this.caseRecords = res.data.caseRecords;
      this.total = res.data.total;
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.getCasesQueryRecords();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getCasesQueryRecords();
    },
    // 删除案件
    async removeById(id) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该案件, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除！");
      }
      const { data: res } = await this.$http.delete(`casesquery/${id}`);
      if (res.meta.status !== 200) {
        console.log(res.meta.msg);
        return this.$message.error("删除失败！");
      }
      this.$message.success("删除成功！");
      this.getCasesQueryRecords();
    },
    // 导出excel
    exprotData() {
      this.$http({
        method: "get",
        url: "casesquery/export",
        responseType: "blob", // 资源的类型
      })
        .then((res) => {
          //   console.log("返回来的数据", res);
          let fileName = `查询记录-${Date.parse(new Date()) / 1000}.xlsx`;
          this.downLoadFile(res.data, fileName, () => {});
        })
        .catch((err) => {
          console.log(err);
        });
    },
    downLoadFile(fileData, fileName, callBack) {
      // 创建Blob实例  fileData 接受的是一个Blob
      let blob = new Blob([fileData], {
        type: "applicationnd.ms-excel",
      });
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // 创建a标签
        const link = document.createElement("a");
        // 隐藏a标签
        link.style.display = "none";
        // 在每次调用 createObjectURL() 方法时，都会创建一个新的 URL 指定源 object的内容
        // 或者说(link.href 得到的是一个地址，你可以在浏览器打开。指向的是文件资源)
        link.href = URL.createObjectURL(blob);
        // console.log("link.href指向的是文件资源", link.href);
        //设置下载为excel的名称
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        // 模拟点击事件
        link.click();
        // 移除a标签
        document.body.removeChild(link);
        // 回调函数，表示下载成功
        callBack(true);
      }
    },
  },
};
</script>
<style scoped>
</style>